import { useState, useEffect } from "react";
import { Download, Share, Plus, MoreVertical } from "lucide-react";

function isStandalone() {
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}
function isIOS() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
}

export function AddToHomeCard() {
  const [deferred, setDeferred] = useState(
    typeof window !== "undefined" ? window.__bwInstallPrompt : null
  );
  const [installed, setInstalled] = useState(isStandalone());
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    const onPrompt = () => setDeferred(window.__bwInstallPrompt);
    const onInstalled = () => {
      setInstalled(true);
      setDeferred(null);
    };
    window.addEventListener("bw-installprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    // pick up an event that may have fired before mount
    if (window.__bwInstallPrompt) setDeferred(window.__bwInstallPrompt);
    return () => {
      window.removeEventListener("bw-installprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed) return null;

  const onClick = async () => {
    if (deferred) {
      // Native Android/Chrome install dialog
      deferred.prompt();
      try {
        const { outcome } = await deferred.userChoice;
        if (outcome === "accepted") setInstalled(true);
      } catch {}
      window.__bwInstallPrompt = null;
      setDeferred(null);
    } else {
      setShowHint((v) => !v);
    }
  };

  const ios = isIOS();

  return (
    <div className="rounded-2xl bg-[#2A0A1B] border border-[#E32C8C]/35 bw-card p-5 mb-4" data-testid="add-to-home-card">
      <button onClick={onClick} data-testid="add-to-home-btn" className="w-full flex items-center gap-4 text-left">
        <span className="w-12 h-12 rounded-2xl flex items-center justify-center shrink-0" style={{ background: "linear-gradient(135deg,#E32C8C,#8E1A52)" }}>
          <Download className="w-6 h-6 text-white" />
        </span>
        <div className="flex-1">
          <p className="font-semibold text-[#F6DCEA] leading-tight">Installa Be Woman</p>
          <p className="text-sm text-[#EAC6D9]">
            {deferred ? "Aggiungila alla schermata Home, come un'app" : "Apri Be Woman a schermo intero, come un'app"}
          </p>
        </div>
      </button>

      {showHint && !deferred && (
        <div className="mt-4 pt-4 border-t border-[#E32C8C]/20 text-sm text-[#EAC6D9] leading-relaxed" data-testid="add-to-home-hint">
          {ios ? (
            <p className="flex items-center gap-1.5 flex-wrap">
              In Safari tocca <Share className="inline w-4 h-4 text-[#FF8FC7]" /><span className="font-semibold text-[#F6DCEA]">Condividi</span> in basso, scorri e scegli
              <Plus className="inline w-4 h-4 text-[#FF8FC7]" /><span className="font-semibold text-[#F6DCEA]">Aggiungi alla schermata Home</span>.
            </p>
          ) : (
            <p className="flex items-center gap-1.5 flex-wrap">
              In Chrome tocca il menu <MoreVertical className="inline w-4 h-4 text-[#FF8FC7]" /> in alto a destra, poi
              <span className="font-semibold text-[#F6DCEA]">Installa app</span> (oppure <span className="font-semibold text-[#F6DCEA]">Aggiungi a schermata Home</span>).
            </p>
          )}
        </div>
      )}
    </div>
  );
}
